import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApexChart, ChartComponent } from "ng-apexcharts";

export type ChartOptions = {
  series: any;
  chart: ApexChart;
  title: any;
  stroke: any;
  fill: any;
  markers: any;
  xaxis: any;
  legend: any;
  plotOptions: any;
  tooltip: any;
  yaxis: any;
};

@Component({
  selector: "app-vew-radar",
  templateUrl: "./vew-radar.component.html",
  styleUrls: ["./vew-radar.component.scss"],
})
export class VewRadarComponent implements OnInit {
  _objectGraphic: any;
  validator: boolean = false;
  valor: any;
  @ViewChild("chart") chart: ChartComponent;
  public ChartOptions: Partial<ChartOptions>;

  @Input() set objectGraphic(value: any) {
    this.validator = this.getValidator(value);
    let argCopy: any = Object.assign({}, value);
    this.ChartOptions = null;
    this.ChartOptions = null;
    this._objectGraphic = argCopy;
    this.ChartOptions = argCopy;
    this.ChartOptions.legend = Object.assign({}, value.legend);
    console.log("en el view radar", value);
    this.valor = value;
  }

  get objectGraphic(): any {
    return this._objectGraphic;
  }

  constructor() {
    this.validator = this.getValidator(this.objectGraphic);
    this.ChartOptions = this.objectGraphic;
  }

  ngOnInit() {
    this.validator = this.getValidator(this.objectGraphic);
    this.ChartOptions = this.objectGraphic;
  }

  getValidator(value) {
    if (value === null || value === undefined) {
      return false;
    } else {
      return true;
    }
  }
}
